import { PricingSheet } from "../types";
import { isResponsiblePerson } from "./isResponsiblePerson";

/**
 * User is either the creator or responsible person of the pricing sheet
 * @param pricingSheet
 * @param userEmail
 * @returns
 */
export const hasSheetOwnerAccess = (
  pricingSheet: Pick<PricingSheet, "userEmail" | "responsiblePerson">,
  userEmail?: string | null,
): boolean => {
  if (!userEmail) {
    return false;
  }
  return (
    userEmail === pricingSheet.userEmail ||
    isResponsiblePerson(pricingSheet, userEmail)
  );
};
